import moment from "moment";
import { FormatNumber2 } from "../../utility/functions/formatNumber";

export const SummaryColumns = (width) => {
    const columns = [
      {
        field: 'CHEQUE_NOS',
        accessor: 'CHEQUE_NOS',

        type: 'string',
        headerAlign: 'center',
        width: width < 768 ? 150 : width < 1400 ? 80 : 60,
        headerClassName: 'super-app-theme--header',
  
        renderCell: (param) => {
          return (
            <div
              className={`h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Cheque NOS'}{' '}
          </div>
        ),
      },

      {
        field: 'CHEQUE_DATE',
        accessor: 'CHEQUE_DATE',
        type: 'date',

        headerAlign: 'center',
        width: width < 768 ? 100 : 100,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          return (
            <div
              className={`h-full w-full flex items-center  `}
            >
              {moment(params.value).format('DD-MM-YYYY')}{' '}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Cheque Date'}{' '}
          </div>
        ),
      },
  
      {
        field: 'PARTY_NAME',
        accessor: 'PARTY_NAME',
        type: 'string',
        width: width < 768 ? 100 : width < 1400 ? 180 : 210,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'center',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center   `}
            >
              {param.value}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            Party Name
          </div>
        ),
      },
     
      {
        field: 'AMOUNT',
        accessor: 'AMOUNT',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 90,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value ? FormatNumber2(param.value) : ''}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
            Amount
          </div>
        ),
      },
      {
        field: 'CHEQUE_CLEAR_DATE',
        accessor: 'CHEQUE_CLEAR_DATE',
        type: 'date',
        headerAlign: 'center',
        width: 150,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          return (
            <div
              className={`h-full w-full flex items-center  `}
            >
              {moment(params.value).format('DD-MM-YYYY')}{' '}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Cheque Clear Date'}{' '}
          </div>
        ),
      },
   
    
    ];


 
    return  columns;
  };

  export const SummaryColumnsPrint = (width) => {
    const columns = [
   

      {
        field: 'CHEQUE_DATE',
        accessor: 'CHEQUE_DATE',
        type: 'date',

        headerAlign: 'center',
        width: width < 768 ? 100 : 100,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          return (
            <div
              className={`h-full w-full flex items-center  `}
            >
              {moment(params.value).format('DD-MM-YYYY')}{' '}
            </div>
          );
        },
        renderHeader: (params) => (
          <div className="text-white" style={{ fontSize: 13 }}>
            {' '}
            {'Cheque Date'}{' '}
          </div>
        ),
      },
  
      {
        field: 'AMOUNT',
        accessor: 'AMOUNT',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 90,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value ? FormatNumber2(param.value) : ''}
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
            Amount
          </div>
        ),
      },
     
      {
        field: 'NO_OF_CHEQUES',
        accessor: 'NO_OF_CHEQUES',
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: width < 768 ? 100 : 90,
        align: 'right',
        renderCell: (param) => {
          return (
            <div
              className={` h-full w-full  flex items-center  justify-end `}
            >
              {param.value }
            </div>
          );
        },
        headerAlign: 'center',
  
        renderHeader: (params) => (
          <div className="text-white  text-center" style={{ fontSize: 13 }}>
            No. of Cheques
          </div>
        ),
      },
   
    
    ];


 
    return  columns;
  };